module.exports = __webpack_public_path__ + "img/header_bg.91048d15.png";